export const AccessDetailsTabs: Record<string, string> = {
  Instructions: 'instructions',
  CLI: 'cli',
  Parameters: 'json',
  Link: 'link',
};
